/**
 * Modal de cambio de subestado de guías
 */

import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import * as FaIcons from 'react-icons/fa';

const SubestadoModal = ({
  show,
  onHide,
  estadosData,
  selectedEstado,
  selectedSubestado,
  onEstadoChange,
  onSubestadoChange,
  onExecute,
  selectedGuiasCount,
  loading
}) => {
  if (!show) return null;

  // Obtener subestados para el estado seleccionado
  const getSubestadosForEstado = () => {
    if (!selectedEstado || !estadosData.length) return [];

    for (const tipo of estadosData) {
      const estado = tipo.estados.find(e => e.id === parseInt(selectedEstado));
      if (estado) {
        return estado.subestados || [];
      }
    }
    return [];
  };

  const subestados = getSubestadosForEstado();
  const selectedSubestadoObj = subestados.find(
    s => s.id === parseInt(selectedSubestado)
  );

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="md"
      centered
      className="subestado-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <FaIcons.FaEdit className="me-2" />
          Cambiar Subestado de Guías
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center py-4">
            <FaIcons.FaSpinner className="fa-spin" size={30} />
            <p className="mt-3">Cargando estados...</p>
          </div>
        ) : (
          <div>
            {/* Selector de Estado */}
            <div className="mb-3">
              <label className="form-label fw-bold">Estado</label>
              <select
                className="form-select"
                value={selectedEstado || ''}
                onChange={(e) => {
                  onEstadoChange(e.target.value);
                }}
              >
                <option value="">Seleccionar estado...</option>
                {estadosData.map(tipo =>
                  tipo.estados.map(estado => (
                    <option key={estado.id} value={estado.id}>
                      {estado.estado}
                    </option>
                  ))
                )}
              </select>
            </div>

            {/* Selector de Subestado */}
            <div className="mb-3">
              <label className="form-label fw-bold">Sub Estado</label>
              <select
                className="form-select"
                value={selectedSubestado || ''}
                onChange={(e) => onSubestadoChange(e.target.value)}
                disabled={!selectedEstado}
              >
                <option value="">
                  {selectedEstado
                    ? 'Seleccionar subestado...'
                    : 'Primero seleccione un estado'}
                </option>
                {subestados.map(subestado => (
                  <option key={subestado.id} value={subestado.id}>
                    {subestado.sub_estado}
                  </option>
                ))}
              </select>
            </div>

            {/* Información */}
            <div className="alert alert-info">
              <FaIcons.FaInfoCircle className="me-2" />
              <strong>Guías seleccionadas:</strong> {selectedGuiasCount}
              <br />
              {selectedEstado && selectedSubestado && (
                <small>
                  Se cambiará el subestado de las guías seleccionadas al estado
                  "{selectedSubestadoObj?.sub_estado}"
                </small>
              )}
            </div>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancelar
        </Button>
        <Button
          variant="success"
          onClick={onExecute}
          disabled={loading || !selectedEstado || !selectedSubestado}
        >
          {loading ? (
            <>
              <FaIcons.FaSpinner className="fa-spin me-2" />
              Actualizando...
            </>
          ) : (
            <>
              <FaIcons.FaCheck className="me-2" />
              Aplicar Cambios
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SubestadoModal;
